import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'

import text from '../constants/Closet'
import sendMessageWPP from '../services/sendMessageWPP'
import CategoryGrid from '../components/CategoryGrid'
import Header from '../components/Header'

import { FiArrowLeft } from 'react-icons/fi'
import API from '../services/Api'
import { useHistory } from 'react-router-dom'

import '../styles/containers/Closet.css'
import EmptyCloset from '../components/EmptyCloset'
import LoadingCloset from '../components/LoadingCloset'

import useLanguage from '../hooks/useLanguage'

const Closet = props => {
  const { push } = useHistory()

  const [isLoading, setIsLoading] = useState(true)
  const [closetCategories, setClosetCategories] = useState([])
  const language = useLanguage()
  const [sendingMessage, setSendingMessage] = useState(false)

  const getCategories = useCallback(async () => {
    setIsLoading(true)

    try {
      const response = await API.getMe(props.token)
      if (response.closetCategories.length > 0) {
        setClosetCategories(response.closetCategories)
        setIsLoading(false)
      } else {
        if (response.userCloset.length > 0) {
          const undefinedCategory = { id: null, name: text._default[language], closetImages: response.userCloset }
          setClosetCategories([undefinedCategory])
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      }
    } catch (err) {
      console.error(err)
    }

    setIsLoading(false)
  }, [props.token, language])

  const requestService = useCallback(async () => {
    const reqServiceMessage = (consultant) => ([
      `Olá ${consultant}. Estou com muita vontade de montar looks para poder colocar no MOSTY, pode me explicar como funciona esse serviço?`,
      `Hello ${consultant}. I really want to mount looks to be able to put on MOSTY, can you explain to me how this service works?`,
      `Hola, ${consultant}. Realmente quiero montar miradas para poder ponerme MOSTY, ¿me pueden explicar cómo funciona este servicio?`
    ])

    setSendingMessage(true)

    try {
      const { consultantName, consultantPhone, consultantPhoneCountryCode } = await API.getUser(props.token)

      sendMessageWPP(
        consultantPhone,
        reqServiceMessage(consultantName)[language],
        consultantPhoneCountryCode
      )
    } catch (err) {
      console.error(err)
    }

    setSendingMessage(false)
  }, [props.token, language])

  const orderCategoryClosetByCreatedAt = closetCategories => {
    if (!closetCategories) {
      return []
    }

    closetCategories.sort((a, b) => {
      const dateA = new Date(a.createdAt)
      const dateB = new Date(b.createdAt)

      return dateB - dateA
    })

    return closetCategories
  }

  const renderContent = useCallback(() => {
    const categories = orderCategoryClosetByCreatedAt(closetCategories)
    if (closetCategories.length > 0) {
      return closetCategories.length === 1 ? <CategoryGrid categories={categories} startOpeningCategory={0} language={language} />
        : <CategoryGrid categories={categories} language={language} />
    }

    return <EmptyCloset language={language} onLinkClick={requestService} />
  }, [closetCategories, language])

  useEffect(() => {
    getCategories()
  }, [])

  return (
    <div className='closet-screen-container'>
      <Header language={language} />
      <div className='closet-screen-title'>
        <FiArrowLeft onClick={() => push('/')}
          size={24} color='var(--primary)' className='closet-screen-goback' />
        <p>{text.title[language]}</p>
      </div>
      {isLoading || sendingMessage ? <LoadingCloset /> : renderContent()}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Closet)



// WEBPACK FOOTER //
// ./src/containers/Closet.js